import { Component } from 'react'
import styles from '~/styles/utils.icon.module.css'

export default class Icon extends Component {
	static getInitialProps() {
		return {
			namespacesRequired: [ 'common' ],
		}
	}
	
	public constructor(props) {
		super(props)
	}
	
	public render(): JSX.Element | null {
		let jsx: JSX.Element | null = null
		if (this.props.name === 'threeDots') {
			jsx = this._getThreeDots()
		} else if (this.props.name === 'nineDots') {
			jsx = this._getNineDots()
		} else {
			jsx = this._getSvgIcon()
		}
		return jsx
	}

	private _getSvgIcon(): JSX.Element | null {
		const icon = Svg.get(this.props.iconName)
		let viewbox = '0 0 24 24'
		if ([ 'chevronUp', 'chevronDown' ].includes(this.props.iconName)) {
			viewbox = '0 0 10 16'
		}
		if (icon) {
			return (
				<div
					className={styles.main}
				>
					<svg
						viewBox={viewbox}
					>
					    <path
					    	fill="currentColor"
					    	d={icon}
					    />
					</svg>
					{this._getHinter()}
				</div>
			)
		} else {
			return null
		}
	}

	private _getHinter(): JSX.Element | null {
		if (this.props.iconHint) {
			return (
				<div
					className={styles.hint}
				>
					<div>
						{this.props.iconHint}
					</div>
				</div>
			)
		} else {
			return null
		}
	}

	private _getThreeDots(): JSX.Element {
		return this._getDots(3, styles.threeDots)
	}

	private _getNineDots(): JSX.Element {
		return this._getDots(9, styles.nineDots)
	}

	private _getDots(count = 0, className): JSX.Element {
		let divs: Array<JSX.Element> = []
		for (let i = 0; i < count; i++) {
			divs.push(this._getDot(i))
		}
		return (
			<div
				className={className}
			>
				{divs}
			</div>
		)
	}

	private _getDot(i): JSX.Element {
		return (
			<div
				key={i}
				className={styles.dot}
			/>
		)
	}
}

export class Base64 {
	static get(name) {
		return (
			<img 
				src={"data:image/png;base64," + Base64[name]}
			/>
		)
	}
}

export class Svg {
	static get(name) {
		return Svg[name]
	}

	static get copy() {
		return 'M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z'
	}

	static get edit() {
		return 'M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z'
	}

	static get split() {
		return 'M14,4L16.29,6.29L13.41,9.17L14.83,10.59L17.71,7.71L20,10V4M10,4H4V10L6.29,7.71L11,12.41V20H13V11.59L7.71,6.29'
	}

	static get close() {
		return 'M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z'
	}

	static get chevronUp() {
		return 'M10 10l-1.5 1.5L5 7.75 1.5 11.5 0 10l5-5 5 5z'
	}

	static get chevronDown() {
		return 'M5 11L0 6l1.5-1.5L5 8.25 8.5 4.5 10 6l-5 5z'
	}

	static get chevronRight() {
		return 'M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z'
	}

	static get sticker() {
		return 'M3,11H5V13H3V11M11,5H13V9H11V5M9,11H13V15H11V13H9V11M15,11H17V13H19V11H21V13H19V15H21V19H19V21H17V19H13V21H11V17H15V15H17V13H15V11M19,19V15H17V19H19M15,3H21V9H15V3M17,5V7H19V5H17M3,3H9V9H3V3M5,5V7H7V5H5M3,15H9V21H3V15M5,17V19H7V17H5Z'
	}
}